import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

const EMPTY_DISABLED_VALUES = []

export default function useDisabledSelector(keyName, storeSchemaKey) {
  const isFullyDisabled = useThreeDStudioStore(state =>
    state.schema?.[storeSchemaKey]?.ui_schema?.[keyName]?.['ui:options']?.disabled
  )
  const disabledValues = useThreeDStudioStore(state =>
    state.schema?.[storeSchemaKey]?.ui_schema?.[keyName]?.['ui:options']?.disabled_values
      ?? EMPTY_DISABLED_VALUES
  )

  return {
    isFullyDisabled,
    disabledValues,
  }
}
